import RouterPage from './Pages/RouterPage';
import { TourismProvider } from './context/TourismContext';
import * as React from 'react'

function App() {
  return (
    <TourismProvider>
      <div className="App">
        <RouterPage />
      </div>
    </TourismProvider>
  );
}

export default App;
